import Protected from "./component";
import ProtectedContainer from "./container";

export { Protected, ProtectedContainer };
export default ProtectedContainer;



// WEBPACK FOOTER //
// ./client/modules/User/components/Protected/index.ts